import { Box } from '@rbilabs/universal-components';

import { InnerLayout } from 'components/layout/styled';

export const ProductComboFlowContainer = Box.withConfig({
  width: 'full',
});

export const ProductComboFlowInnerLayout = InnerLayout.withConfig({
  marginY: 0,
  paddingY: 0,
});
